
window.addEventListener('cartcount:update', checkForWalls)
window.addEventListener('custom:payment-btn-init', checkForWalls)
document.addEventListener('DOMContentLoaded', checkForWalls);

let allSingleBoardsIds = [];
let allWallKitsIds = [];

async function checkForWalls() {

  Promise.all([getSingleBoardProducts(), getAllWallsProducts(), getCart()]).then((values) => {
    values[0].products.forEach(item=>{
      allSingleBoardsIds.push(item.id);
    })
    values[1].products.forEach(item=>{
      allWallKitsIds.push(item.id);
    })
    onCartUpdate(values[2], 'onload');
  });
}

async function getCart(){
  return await fetch('/cart.js').then(data=>data.json());
}

function getSingleBoardProducts(){
  return fetch('/collections/single-boards-collection/products.json').then(data=>data.json());
}

function getAllWallsProducts(){
  return fetch('/collections/wall-kits-collection/products.json').then(data=>data.json());
}

function onCartUpdate(e, type = ''){
  let enableCheckoutBtn = true;
  let haveWallKit = false;

  let items = {};
  if(type == 'onload') {
    items = e.items;
  } else {
    items = e.detail.items;
  }


  if(document.querySelectorAll('.cart--section .cartitems--list .cart-item').length > items.length) {
    location.reload();
  }

  items.forEach((item)=>{
    if(allWallKitsIds.includes(item.product_id)) {
      haveWallKit = true;
    }
  })

  
  if(haveWallKit){
    enableCheckoutBtn = true;
  } else {
    enableCheckoutBtn = false;
  }

  if(enableCheckoutBtn) {
    allSingleBoardsIds.forEach(singleBoardId=>{
      document.querySelectorAll(`.product-form--regular[data-product-id="${singleBoardId}"]`).forEach(el=>{
        el.classList.remove('product-form--regular--hide-btns');
        document.querySelectorAll('.single-wall-notice').forEach(el=>{
          el.remove();
        })
      })
      
      document.querySelectorAll(`button[data-product-id="${singleBoardId}"]`).forEach(btn=>{
        btn.setAttribute('type', 'submit')
        btn.removeAttribute('disabled', 'disabled')
        btn.classList.remove('disabled')

        // plp
        if(btn.matches('.productitem--action-trigger')) {
          btn.classList.remove('hidden');
        }
      })

      document.querySelectorAll(`.product-form--regular[data-product-id="${singleBoardId}"]`).forEach(el=>{
        el.classList.remove('product-form--regular--hide-btns');
      })
    })
  } else {
    allSingleBoardsIds.forEach(singleBoardId=>{
      document.querySelectorAll(`button[data-product-id="${singleBoardId}"]`).forEach(btn=>{
        // plp
        if(btn.matches('.productitem--action-trigger')) {
          btn.classList.add('hidden');
        }

        // pdp
        if(btn.matches('.product-form--atc-button')) {
          btn.addEventListener('click', (e)=>{
            e.preventDefault();
            if(!btn.parentNode.querySelector('.single-wall-notice')) {
              btn.parentNode.insertAdjacentHTML("afterbegin", '<div class="single-wall-notice">Single Redi Wall boards cannot be sold individually. They must be sold in addition to the purchase of a Redi Wall Kit.</div>');
            }
            
            btn.classList.add('disabled')
            btn.setAttribute('disabled', 'disabled')
          })
        }
      })

      document.querySelectorAll(`.product-form--regular[data-product-id="${singleBoardId}"]`).forEach(el=>{
        el.classList.add('product-form--regular--hide-btns');
      })
    })

    removeSingleBoardsFromCart(items);

  }
}

function onRemoveLinks(e) {
  e.preventDefault();
}

function removeSingleBoardsFromCart(items) {
  let cartItemsIds = items.map((item) => item.id);
  let cartItemsProductIds = items.map((item) => item.product_id);

  let idsForRemove = {}
  allSingleBoardsIds.forEach(sBoardId=>{
    if(cartItemsProductIds.includes(sBoardId)) {
      idsForRemove[cartItemsIds[cartItemsProductIds.findIndex(el => el == sBoardId)]] = 0;
    }
  })

  if(Object.keys(idsForRemove).length) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: idsForRemove
      })
    }).then(data=>data.json()).then(data=> {
      location.reload()
    });
  }
  
}